import config from '@/config/config';
import { del, get, patch, post, put } from '@/helpers/api.helper';
export const getChatShortLink = async (userId: string, productGroupId: string) => {
    return get(
        `/users/${userId}/short-link?mallProductGroupId=${productGroupId}`,
        { baseURL: config.api.chat2_api }
    )
}